import React from 'react';
import { Button } from '@tvg/fuse/button';
import { Link } from '@tvg/fuse/link';
import { Modal } from '@tvg/fuse/modal';
import { Typography } from '@tvg/fuse/typography';
import styles from './ErrorDialog.module.css';

interface Props {
  open: boolean;
  closeDialog: () => void;
  onCancelCallback: () => void;
  onCloseCallback: () => void;
  onReloadCallback: () => void;
}

function ErrorDialog(props: Props) {
  const { open, closeDialog, onCancelCallback, onCloseCallback, onReloadCallback } = props;

  const reloadPage = () => window.location.reload();

  const onCancelCallbackHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    closeDialog();
    onCancelCallback();
  };

  const onCloseCallbackHandler = () => {
    closeDialog();
    onCloseCallback();
  };

  const onReloadClickHandler = () => {
    onReloadCallback();
    reloadPage();
  };

  return (
    <Modal
      name="error_dialog"
      open={open}
      onClose={onCloseCallbackHandler}
      title="Oops"
      titleTag="h2"
      dataTestId="error_dialog"
      srLabelCloseButton="close error dialog"
      zIndex="25"
    >
      <div className={styles.dialogContent}>
        <Typography type="paragraph" size="1" tag="p">
          It looks like we&apos;ve had a little hiccup.
        </Typography>

        <Button
          className={styles.errorButton}
          onClick={onReloadClickHandler}
          dataTestId="error-dialog_reload"
          size="large"
          variant="primary"
          fullWidth
        >
          Reload
        </Button>

        <Link
          className={styles.errorLink}
          href="#"
          onClick={onCancelCallbackHandler}
          dataTestId="error-dialog_cancel"
          size="medium"
          isButton
        >
          Cancel and close
        </Link>
      </div>
    </Modal>
  );
}

export default ErrorDialog;
